export default class Employee {
  public static readonly SET_LIST = "COMPANY_EMPLOYEE_SET_LIST";
  public static readonly SET_STATUS = "COMPANY_EMPLOYEE_SET_STATUS";
  public static readonly SET_ERROR = "COMPANY_EMPLOYEE_SET_ERROR";
  public static readonly CLEAR = "COMPANY_EMPLOYEE_CLEAR";

  public static setList(data: any[]) {
    return {
      data,
      type: Employee.SET_LIST,
    };
  }

  public static setStatus(data: any) {
    return {
      data,
      type: Employee.SET_STATUS,
    };
  }

  public static setError(data: any) {
    return {
      data,
      type: Employee.SET_ERROR,
    };
  }

  public static clear() {
    return {
      type: Employee.CLEAR,
    };
  }
}
